<template>
  <div class="register">
    <div class="register-box">
      <div class="register-logo" v-if="site">
        <img :src="site.pcWebsiteLogo ? site.pcWebsiteLogo : '../assets/pic/login-logo.png'" width="185" />
      </div>
      <div class="form">
        <el-form :model="form" ref="form" class="form">
          <div class="register-form">
            <div class="email" id="username">
              <el-form-item prop="username" :rules="[{ validator: checkUsername, trigger: 'blur' }]">
                <div class="item-icon" >
                  <img src="../assets/images/icon-user-black2.svg" class="h-5 w-5 object-contain" alt="" />
                </div>
                <el-input v-model="form.username" :placeholder="ts('Enter an email address for your account')['Enter an email address for your account']"></el-input>
              </el-form-item>
            </div>
            <div class="password" id="password1">
              <el-form-item prop="password" :rules="[{ validator: validatePass, trigger: 'blur' }]">
                <div class="item-icon" >
                  <img src="../assets/images/icon-password2.svg" class="h-5 w-5 object-contain" alt="" />
                </div>
                <el-input type="password" v-model="form.password" :placeholder="ts('Create a password for your account')['Create a password for your account']" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <div class="password" id="password2">
              <el-form-item prop="checkPass" :rules="[{ validator: validatePass2, trigger: 'blur' }]">
                <div class="item-icon" >
                  <img src="../assets/images/icon-password1.svg" class="h-5 w-5 object-contain" alt="" />
                </div>
                <el-input type="password" v-model="form.checkPass" :placeholder="ts('Confirm password')['Confirm password']" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <div class="code" id="code">
              
              <el-form-item prop="smscode" :rules="[{ validator: codePass, message: ts('不能为空')['不能为空'] }]">
                <div class="item-icon" >
                  <img src="../assets/images/icon-code1.svg" class="h-5 w-5 object-contain" alt="" />
                </div>
                <el-input v-model="form.smscode" :placeholder="ts('Verification Code')['Verification Code']" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <el-button class="btn-code" :disabled="state.smsSendBtn" @click="getCaptcha">{{ (!state.smsSendBtn && ts('Get Verification Code')['Get Verification Code']) || state.time + ' s' }}</el-button>
          </div>
          <div class="register-submit">
            <el-button type="primary" class="btn btn-theme" @click="submitForm('form')" :loading="btnLoading">{{ ts('Sign-up')['Sign-up'] }}</el-button>
          </div>
          <router-link class="to-login" to="/login">{{ ts('Login with an existing account')['Login with an existing account'] }}</router-link>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import { mapState } from 'vuex'
import CustomerService from '@/components/CustomerService.vue'
import tippy from 'tippy.js';

export default {
  name: 'Register',
  mixins: [LanguagePackage],
  data() {
    return {
      form: {
        username: '',
        password: '',
        checkPass: '',
        smscode: '',
        // parentid: this.$ls.get('fromId'),
      },
      state: {
        time: 60,
        smsSendBtn: false,
      },
      btnLoading: false,
    }
  },
  computed: {
    ...mapState(['site']),
  },
  methods: {
    checkUsername(rule, value, callback) {
      let reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
       const usernameTip  = tippy(document.getElementById('username'));
      if (!reg.test(value)) {
        // callback(new Error(this.translate('Please enter the correct email address')))
        usernameTip.setContent(this.translate('Please enter the correct email address'))
        usernameTip.show();
      }

      if (!value) {
        // callback(new Error(this.translate('请输入邮箱')))
        usernameTip.setContent(this.translate('请输入邮箱'))
        usernameTip.show();
      } else {
        // callback()
        getAction(`/pc/home/checkOnlyUser`, {
          username: value,
        }).then((res) => {
          console.log(res)
          if (res.success) {
            callback()
          } else {
            // callback(this.translate('Username already exists'))
            usernameTip.setContent(this.translate('Username already exists'))
            usernameTip.show();
          }
        })
      }
    },
    validatePass(rule, value, callback) {
      const password1Tip  = tippy(document.getElementById('password1'));
      if (value === '') {
        // callback(new Error(this.translate('请输入密码')))
        password1Tip.setContent(this.translate('请输入密码'))
        password1Tip.show();
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    },
    validatePass2(rule, value, callback) {
      const password2Tip  = tippy(document.getElementById('password2'));
      if (value === '') {
        // callback(new Error(this.translate('请再次输入密码')))
        password2Tip.setContent(this.translate('请再次输入密码'))
        password2Tip.show();
      } else if (value !== this.form.password) {
        // callback(new Error(this.translate('两次输入密码不一致!')))
        password2Tip.setContent(this.translate('两次输入密码不一致'))
        password2Tip.show();
      } else {
        callback()
      }
    },
    codePass(rule, value, callback) {
      const codeTip  = tippy(document.getElementById('code'));
      if (value === '') {
        // callback(new Error(this.translate('请输入验证码')))
        codeTip.setContent(this.translate('请输入验证码'))
        codeTip.show();
      } else {
        callback()
      }
    },

    getCaptcha() {
      let that = this
      this.$refs.form.validateField('username', (err) => {
        if (!err) {
          this.state.smsSendBtn = true
          let interval = window.setInterval(() => {
            if (that.state.time-- <= 0) {
              that.state.time = 60
              that.state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)
          // const hide = this.$message.loading('验证码发送中..', 0)
          const data = {
            username: that.form.username,
            smsmode: '1',
          }
          postAction(`/pc/home/sms`, {
            username: this.form.username,
            smsmode: 1,
          })
            .then((res) => {
              this.$message({
                message: this.translate('验证码已发送'),
                type: 'success',
              })
              // if (!res.success) {
              //   setTimeout(hide, 0)
              // }
              // setTimeout(hide, 500)
            })
            .catch((err) => {
              // setTimeout(hide, 1)
              clearInterval(interval)
              that.state.time = 60
              that.state.smsSendBtn = false
            })
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        this.btnLoading = true
        if (valid) {
          let params = { ...this.form }
          delete params.checkPass
          postAction(`/pc/home/pmsRegister`, params).then((res) => {
            console.log(res)
            if (!res.success) {
              console.log(res.message)
            } else {
              this.$router.push('/login')
            }
            this.btnLoading = false
          })
        } else {
          console.log('error submit!!')
          this.btnLoading = false
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
.register {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
.register-box {
  width: 500px;
  padding: 40px 70px;
  background: #fff;
  border-radius: 10px;
}
.register-logo {
  margin-bottom: 20px;
  text-align: center;
}

.btn-code {
  width: 100%;
  height: 40px;
  padding: 0;
  line-height: 38px;
  font-size: 16px;
  border: 1px solid #dcdfe6;
  text-align: center;
  border-radius: 4px;
}

.register-submit {
  margin-top: 20px;
  text-align: center;
  .btn {
    min-width: 140px;
  }
}


</style>
